import { Icon } from './Icon';

export { default as iconMixin } from './iconMixin';
export { Icon, Icon as default };
export * from './theme';
